<template>
  <div id="woc-uh">
    <wo-universal-header class="po-universal-header" >
      <po-tabs slot="tabs" mod-no-borders :tabs="mainNavigation" />

      <header-brand slot="brand" :xs-actions="userActions"/>

      <wo-universal-header-toolbar slot="toolbar" v-if="currentUser">
        <wo-universal-header-toolbar-item>
          <po-action-dropdown :actions="userActions" :label="currentUser.display_name" mod-right mod-toggle-subtle />
        </wo-universal-header-toolbar-item>
      </wo-universal-header-toolbar>
    </wo-universal-header>
  </div>
</template>
<script>

import _ from 'lodash'

import { mapState } from 'vuex'
import { SIGNIN } from '@/routes/identity'

import { ApplicationModuleEnum } from '@/model/environment'

import { setApplicationModule } from '@/store'

import HeaderBrand from '@/components/header/HeaderBrand'

export default {
  components: { HeaderBrand },
  props: {
    mainNavigation: Array
  },
  computed: mapState({
    currentUser: state => state.identity.currentUser,
    userActions () {
      return [
        { id: 'logout', labelKey: 'general.action.signOut', icon: 'exit', execute: this.logout }
      ]
    }
  }),
  methods: {
    logout (callback) {
      this.$router.push({ name: SIGNIN, params: { signOut: true } })
    },
    init (id) {
      const appModule = _.find(ApplicationModuleEnum.values, a => a.id === id || a.alias === id)
      if (appModule) {
        setApplicationModule(this.$store, appModule)
      }
    }
  }
}
</script>
